import injectCSS from "../../html/inject-css";
import SectionMarker from "./section-marker";

export class SingleWallComponent extends HTMLElement {

    canvas: HTMLCanvasElement;
    markers: SectionMarker[];

    constructor(markers: SectionMarker[]) {
        super();
        injectCSS(STYLESHEET);

        this.markers = markers;
        this.canvas = document.createElement('canvas');
    }

    connectedCallback() {
        this.replaceChildren();
        this.append(this.canvas);
        this.append(...this.markers);
    }
}
window.customElements.define('single-wall-component', SingleWallComponent);
export default SingleWallComponent;

const STYLESHEET = `
single-wall-component {
    display: block;
    position: relative;

    & canvas {
        width: 100%;
        height: 100%;
    }
}
`;
